// import React, { useState, useEffect, useRef, useContext } from 'react';
// import { 
//   Search, Menu, X, ShoppingCart, User, LogOut, 
//   Package, Settings, ChevronDown, Bell, Heart, Smartphone, Wrench,
//   RefreshCw, Upload, Gift, CreditCard, Mail, Sparkles
// } from 'lucide-react';
// import { useSelector, useDispatch } from 'react-redux';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { summaryApi } from '../../common';
// import { toast } from 'react-toastify';
// import { setUserDetails } from '../../store/userSlice';
// import { isAdminRole } from '../../common/role';
// import Context from '../../context';
// import { useTheme } from '../Theme/ThemeProvider';
// import ThemeToggle from '../Theme/ThemeToggle';
// import { logo1 } from '../Logo/Logo';
// import NotificationBell from '../Notification/NotificationBell';
// // import { getFullImageUrl } from 'helpers/imageHelper';

// const Header = () => {
//   const { colors } = useTheme();
//   const user = useSelector((state) => state?.user?.user);
//   const dispatch = useDispatch();
//   const context = useContext(Context);
//   const navigate = useNavigate();

//   const [selectedLogo, setSelectedLogo] = useState(logo1);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isProfileOpen, setIsProfileOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const profileRef = useRef(null);
//   const dropdownRef = useRef(null);

//   const searchInput = useLocation();
//   const URLSearch = new URLSearchParams(searchInput?.search);
//   const searchQueryParam = URLSearch.getAll("q");

//   const getFullImageUrl = (user) => {
//   if (!user) return null;
  
//   // Use picturePath instead of profilePic
//   const picturePath = user.picturePath;
  
//   if (!picturePath) return null;
  
//   // If it's already a Cloudinary URL or full URL, return as is
//   if (picturePath.startsWith('http')) {
//     return picturePath;
//   }
  
//   // If it's a local upload path, construct the full URL
//   const cleanPath = picturePath.replace(/\\/g, '/').replace(/^\/+/, '');
//   return `${process.env.REACT_APP_BACKEND_URL}/${cleanPath}`;
// };

// const profilePicUrl = getFullImageUrl(user);

// // Debug logs
// console.log("User picturePath:", user?.picturePath);
// console.log("Constructed URL:", profilePicUrl);


  

// useEffect(() => {
//   const storedUser = localStorage.getItem('user');
//   console.log("Stored user in localStorage:", storedUser);
//   if (storedUser) {
//     try {
//       const parsedUser = JSON.parse(storedUser);
//       console.log("Parsed user from localStorage:", parsedUser);
//       console.log("ProfilePic in localStorage:", parsedUser?.profilePic);
//     } catch (error) {
//       console.error("Error parsing stored user:", error);
//     }
//   }
// }, []);

//   useEffect(() => {
//     if (searchQueryParam.length > 0) {
//       setSearchQuery(searchQueryParam[0]);
//     }
//   }, [searchQueryParam]);

//   useEffect(() => {
//     const handleScroll = () => setIsScrolled(window.scrollY > 10);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (profileRef.current && !profileRef.current.contains(e.target)) {
//         setIsProfileOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Lock body scroll when mobile menu is open
//   useEffect(() => {
//     if (isMobileMenuOpen) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }
//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [isMobileMenuOpen]);

//   useEffect(() => {
//     const fetchCurrentLogo = async () => {
//       try {
//         const response = await fetch(summaryApi.getLogo.url, {
//           method: summaryApi.getLogo.method,
//           credentials: 'include'
//         });
        
//         if (response.ok) {
//           const data = await response.json();
//           if (data.success && data.logo) {
//             setSelectedLogo(data.logo.cloudinaryUrl);
//           } else {
//             setSelectedLogo(logo1);
//           }
//         } else {
//           setSelectedLogo(logo1);
//         }
//       } catch (error) {
//         console.error('Error fetching logo:', error);
//         setSelectedLogo(logo1);
//       }
//     };

//     fetchCurrentLogo();
//   }, []);

//   const handleLogout = async () => {
//     const response = await fetch(summaryApi.logout.url, {
//       method: summaryApi.logout.method,
//       credentials: "include",
//     });
//     const data = await response.json();

//     if (data.success) {
//       toast.success(data.message);
//       dispatch(setUserDetails(null));
//       localStorage.removeItem("token");
//       setIsMobileMenuOpen(false);
//       setIsProfileOpen(false);
//       navigate("/");
//     }

//     if (data.error) {
//       toast.error(data.message);
//     }
//   };

//   const handleSearch = (e) => {
//     if (e.key === 'Enter' || e.type === 'click') {
//       if (searchQuery.trim()) {
//         navigate(`/search?q=${searchQuery}`);
//         setIsMobileMenuOpen(false);
//       }
//     }
//   };

//   const handleEditProfile = () => {
//     setIsProfileOpen(false);
//     setIsMobileMenuOpen(false);
//     navigate('/profile');
//   };

//   const closeMobileMenu = () => {
//     setIsMobileMenuOpen(false);
//   };

//   return (
//     <>
//       <header
//         className="fixed w-full top-0 z-50 transition-all duration-300"
//         style={{
//           backgroundColor: colors.bg,
//           backdropFilter: 'blur(10px)',
//           WebkitBackdropFilter: 'blur(10px)', // Safari support
//           borderBottom: `1px solid ${colors.border}`,
//           boxShadow: isScrolled ? `0 4px 20px ${colors.shadow}` : 'none'
//         }}
//       >
//         {/* Top Bar - Accent Gradient */}
//         <div
//           className="h-1 w-full"
//           style={{
//             background: `linear-gradient(90deg, ${colors.primary}, ${colors.accent}, ${colors.primaryLight})`
//           }}
//         />

//         <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
//           <div className="flex items-center justify-between h-14 sm:h-16">
            
//             {/* Logo Section */}
//             <Link to="/" className="flex-shrink-0">
//               <div
//                 className="text-lg sm:text-2xl font-black tracking-tight flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
//                 style={{ color: colors.primary }}
//               >
//                 <div
//                   className="w-10 h-10 sm:w-14 sm:h-14 rounded-lg flex items-center justify-center text-white font-bold transition-transform hover:scale-110"
//                   style={{ backgroundColor: colors.primary }}
//                 >
//                   {selectedLogo ? (
//                     selectedLogo.endsWith('.mp4') || selectedLogo.includes('/video/') ? (
//                       <video
//                         src={selectedLogo}
//                         className="h-full w-full object-cover rounded-lg"
//                         autoPlay
//                         muted
//                         loop
//                         playsInline
//                       />
//                     ) : (
//                       <img
//                         src={selectedLogo}
//                         alt="Company Logo"
//                         className="h-full w-full object-cover rounded-lg"
//                       />
//                     )
//                   ) : (
//                     <div className="h-full w-full bg-gray-200 rounded-lg flex items-center justify-center">
//                       <span className="text-xs text-gray-500">Logo</span>
//                     </div>
//                   )}
//                 </div>
//                 <span className="hidden sm:inline">JosiePhones</span>
//               </div>
//             </Link>

//             {/* Desktop Search Bar */}
//             <div className="hidden md:flex flex-1 max-w-md mx-8">
//               <div className="w-full relative">
//                 <div
//                   className="absolute inset-0 rounded-full blur-lg opacity-20 transition-all"
//                   style={{
//                     backgroundColor: colors.primary
//                   }}
//                 />
//                 <div
//                   className="relative flex items-center gap-3 px-5 py-2.5 rounded-full transition-all hover:shadow-md"
//                   style={{
//                     backgroundColor: colors.bgSecondary,
//                     border: `1px solid ${colors.border}`
//                   }}
//                 >
//                   <Search size={18} style={{ color: colors.textSecondary }} />
//                   <input
//                     type="text"
//                     placeholder="Search products..."
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                     onKeyDown={handleSearch}
//                     className="flex-1 outline-none text-sm"
//                     style={{
//                       backgroundColor: 'transparent',
//                       color: colors.text
//                     }}
//                   />
//                   <button
//                     onClick={handleSearch}
//                     className="transition-all hover:scale-110"
//                     style={{ color: colors.primary }}
//                   >
//                     <Search size={18} />
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Right Actions */}
//             <div className="flex items-center gap-2 sm:gap-4">
//               {/* Desktop Actions */}
//               <div className="hidden lg:flex items-center gap-3">
//                 {user?._id && (
//                   <NotificationBell />
//                 )}

//                 {user?._id && (
//                   <Link 
//                     to="/liked-products"
//                     className="p-2 rounded-lg transition-all hover:scale-110 active:scale-95"
//                     style={{
//                       backgroundColor: colors.bgTertiary,
//                       color: colors.accent
//                     }}
//                     title="Liked Products"
//                   >
//                     <Heart size={20} fill="none" />
//                   </Link>
//                 )}

//                 {user?._id && (
//                   <Link to="/cart" className="relative">
//                     <button
//                       className="p-2 rounded-lg transition-all hover:scale-110"
//                       style={{
//                         backgroundColor: colors.bgTertiary,
//                         color: colors.primary
//                       }}
//                       title="Shopping Cart"
//                     >
//                       <ShoppingCart size={20} />
//                       {context?.cartCount > 0 && (
//                         <span
//                           className="absolute -top-1 -right-1 w-5 h-5 rounded-full text-xs font-bold flex items-center justify-center text-white"
//                           style={{ backgroundColor: colors.accent }}
//                         >
//                           {context.cartCount}
//                         </span>
//                       )}
//                     </button>
//                   </Link>
//                 )}
//               </div>

//               {/* Theme Toggle */}
//               <ThemeToggle />

//               {/* Profile Section - Desktop */}
//               {user?._id ? (
//                 <div className="relative" ref={profileRef}>
//                   <button
//                     onClick={() => setIsProfileOpen(!isProfileOpen)}
//                     className="hidden md:flex items-center gap-2 px-3 py-2 rounded-lg transition-all hover:scale-105"
//                     style={{
//                       backgroundColor: colors.bgTertiary,
//                       color: colors.text
//                     }}
//                   >
//                     <div className="relative">
//                       {profilePicUrl ? (
//                         <img 
//                           src={profilePicUrl} 
//                           alt={user.firstName} 
//                           className="w-10 h-10 rounded-full object-cover border-2 transition-all hover:scale-110"
//                           style={{ borderColor: colors.primary }}
//                           onError={(e) => {
//                             e.target.onerror = null;
//                             e.target.style.display = 'none';
//                             e.target.nextSibling.style.display = 'flex';
//                           }}
//                         />
//                       ) : null}
//                       <div
//                         className={`${profilePicUrl ? 'hidden' : 'flex'} w-10 h-10 rounded-full items-center justify-center text-white font-bold text-sm border-2 transition-all hover:scale-110`}
//                         style={{ 
//                           background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//                           borderColor: colors.primary
//                         }}
//                       >
//                         {user.firstName?.charAt(0) || 'U'}
//                       </div>
//                       <div 
//                         className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2"
//                         style={{ 
//                           backgroundColor: colors.accent,
//                           borderColor: colors.bg
//                         }}
//                       />
//                     </div>

//                     <span className="text-sm font-medium hidden sm:inline">
//                       {user?.firstName}
//                     </span>
//                     <ChevronDown
//                       size={16}
//                       className={`transition-transform ${isProfileOpen ? 'rotate-180' : ''}`}
//                     />
//                   </button>

//                   {/* Profile Dropdown Menu */}
//                   {isProfileOpen && (
//                     <div
//                       ref={dropdownRef}
//                       className="absolute right-0 mt-3 w-80 rounded-2xl shadow-2xl overflow-hidden animate-slideIn backdrop-blur-xl"
//                       style={{
//                         backgroundColor: `${colors.bgSecondary}f5`,
//                         border: `1px solid ${colors.border}`,
//                         boxShadow: `0 20px 60px ${colors.shadow}`,
//                         maxHeight: 'calc(100vh - 100px)',
//                         overflowY: 'auto'
//                       }}
//                     >
//                       {/* Profile Header */}
//                       <div
//                         className="relative p-6 overflow-hidden"
//                         style={{ 
//                           background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//                         }}
//                       >
//                         <div className="relative flex flex-col items-center text-center gap-3">
//                           <div className="relative group/avatar">
//                             {profilePicUrl ? (
//                               <img 
//                                 src={profilePicUrl} 
//                                 alt={user.firstName} 
//                                 className="relative w-20 h-20 rounded-full object-cover border-4 shadow-xl transition-transform group-hover/avatar:scale-110"
//                                 style={{ borderColor: 'rgba(255,255,255,0.9)' }}
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.style.display = 'none';
//                                   e.target.nextSibling.style.display = 'flex';
//                                 }}
//                               />
//                             ) : null}
//                             <div
//                               className={`${profilePicUrl ? 'hidden' : 'flex'} relative w-20 h-20 rounded-full items-center justify-center text-2xl font-bold text-white border-4 shadow-xl`}
//                               style={{ 
//                                 backgroundColor: colors.primaryDark,
//                                 borderColor: 'rgba(255,255,255,0.9)'
//                               }}
//                             >
//                               {user.firstName?.charAt(0) || 'U'}
//                             </div>
//                             <div 
//                               className="absolute -top-1 -right-1 p-1.5 rounded-full shadow-lg"
//                               style={{ backgroundColor: '#fbbf24' }}
//                             >
//                               <Sparkles size={12} color="white" fill="white" />
//                             </div>
//                           </div>
                          
//                           <div>
//                             <p className="font-bold text-white text-lg">{user?.firstName} {user?.lastName}</p>
//                             <p className="text-sm text-white/90 mt-0.5">{user?.email}</p>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Menu Items */}
//                       <div className="py-2 px-2">
//                         <button 
//                           onClick={handleEditProfile}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ 
//                             color: colors.text, 
//                             backgroundColor: 'transparent',
//                           }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: `${colors.primary}15` }}
//                           >
//                             <User size={18} style={{ color: colors.primary }} />
//                           </div>
//                           <div className="flex-1 text-left">
//                             <div className="text-sm font-semibold">Edit Profile</div>
//                             <div className="text-xs" style={{ color: colors.textSecondary }}>Update your information</div>
//                           </div>
//                         </button>

//                         <Link 
//                           to="/orders"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: `${colors.accent}15` }}
//                           >
//                             <Package size={18} style={{ color: colors.accent }} />
//                           </div>
//                           <div className="flex-1 text-left">
//                             <div className="text-sm font-semibold">Order History</div>
//                             <div className="text-xs" style={{ color: colors.textSecondary }}>Track your orders</div>
//                           </div>
//                         </Link>

//                         {/* Gift Cards Section */}
//                         <div className="my-2 px-4">
//                           <div 
//                             className="h-px"
//                             style={{ backgroundColor: colors.border }}
//                           />
//                           <div className="text-xs font-semibold mt-2 mb-1" style={{ color: colors.textSecondary }}>
//                             Gift Cards
//                           </div>
//                         </div>

//                         <Link 
//                           to="/purchase-giftcard"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: '#10b98115' }}
//                           >
//                             <Gift size={18} style={{ color: '#10b981' }} />
//                           </div>
//                           <span className="text-sm font-medium">Send Gift Card</span>
//                         </Link>

//                         <Link 
//                           to="/my-giftcards"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: '#10b98115' }}
//                           >
//                             <CreditCard size={18} style={{ color: '#10b981' }} />
//                           </div>
//                           <span className="text-sm font-medium">My Gift Cards</span>
//                         </Link>

//                         <Link 
//                           to="/received-giftcards"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: '#10b98115' }}
//                           >
//                             <Mail size={18} style={{ color: '#10b981' }} />
//                           </div>
//                           <span className="text-sm font-medium">Received Gifts</span>
//                         </Link>

//                         {/* Trade-Ins Section */}
//                         <div className="my-2 px-4">
//                           <div 
//                             className="h-px"
//                             style={{ backgroundColor: colors.border }}
//                           />
//                           <div className="text-xs font-semibold mt-2 mb-1" style={{ color: colors.textSecondary }}>
//                             Trade-Ins
//                           </div>
//                         </div>

//                         <Link 
//                           to="/my-tradeins"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: `${colors.accent}15` }}
//                           >
//                             <RefreshCw size={18} style={{ color: colors.accent }} />
//                           </div>
//                           <span className="text-sm font-medium">My Trade-Ins</span>
//                         </Link>

//                         <Link 
//                           to="/submit-tradein"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: `${colors.accent}15` }}
//                           >
//                             <Upload size={18} style={{ color: colors.accent }} />
//                           </div>
//                           <span className="text-sm font-medium">Submit Trade-In</span>
//                         </Link>

//                         {/* Repairs Section */}
//                         <div className="my-2 px-4">
//                           <div 
//                             className="h-px"
//                             style={{ backgroundColor: colors.border }}
//                           />
//                           <div className="text-xs font-semibold mt-2 mb-1" style={{ color: colors.textSecondary }}>
//                             Repair Requests
//                           </div>
//                         </div>

//                         <Link 
//                           to="/repair-requests"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: `${colors.accent}15` }}
//                           >
//                             <Wrench size={18} style={{ color: colors.accent }} />
//                           </div>
//                           <span className="text-sm font-medium">Request Repairs</span>
//                         </Link>

//                         <Link 
//                           to="/repair-lists"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: `${colors.accent}15` }}
//                           >
//                             <Smartphone size={18} style={{ color: colors.accent }} />
//                           </div>
//                           <span className="text-sm font-medium">Repair Lists</span>
//                         </Link>

//                         {isAdminRole(user?.role) && (
//                           <>
//                             <div className="my-2 px-4">
//                               <div 
//                                 className="h-px"
//                                 style={{ backgroundColor: colors.border }}
//                               />
//                             </div>
//                             <Link
//                               to="/admin"
//                               onClick={() => setIsProfileOpen(false)}
//                               className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                               style={{ color: colors.text, backgroundColor: 'transparent' }}>
//                               <div 
//                                 className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                                 style={{ backgroundColor: `${colors.primary}15` }}
//                               >
//                                 <Settings size={18} style={{ color: colors.primary }} />
//                               </div>
//                               <span className="text-sm font-medium">Admin Panel</span>
//                             </Link>
//                           </>
//                         )}
//                       </div>

//                       {/* Cart and Logout Section */}
//                       <div className="p-2 space-y-2">
//                         <Link 
//                           to="/cart"
//                           onClick={() => setIsProfileOpen(false)}
//                           className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all group/item"
//                           style={{ 
//                             color: colors.text, 
//                             backgroundColor: `${colors.primary}10`,
//                             border: `1px solid ${colors.border}`
//                           }}>
//                           <div 
//                             className="p-2 rounded-lg group-hover/item:scale-110 transition-transform"
//                             style={{ backgroundColor: `${colors.primary}20` }}
//                           >
//                             <ShoppingCart size={18} style={{ color: colors.primary }} />
//                           </div>
//                           <div className="flex-1 text-left">
//                             <div className="text-sm font-semibold">Shopping Cart</div>
//                             {context?.cartCount > 0 && (
//                               <div className="text-xs" style={{ color: colors.accent }}>
//                                 {context.cartCount} item{context.cartCount !== 1 ? 's' : ''} in cart
//                               </div>
//                             )}
//                           </div>
//                         </Link>

//                         <button 
//                           onClick={handleLogout}
//                           className="w-full px-4 py-3 flex items-center justify-center gap-2 rounded-xl transition-all hover:scale-[1.02] active:scale-95 group/logout relative overflow-hidden"
//                           style={{ 
//                             color: 'white',
//                             background: `linear-gradient(135deg, ${colors.accent}, ${colors.accent}dd)`
//                           }}>
//                           <div 
//                             className="absolute inset-0 opacity-0 group-hover/logout:opacity-100 transition-opacity"
//                             style={{
//                               background: `linear-gradient(135deg, ${colors.accent}dd, ${colors.accent})`
//                             }}
//                           />
//                           <LogOut size={18} className="relative" />
//                           <span className="text-sm font-semibold relative">Logout</span>
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <Link
//                   to="/login"
//                   className="hidden md:block px-4 sm:px-6 py-2 rounded-lg font-bold text-white transition-all hover:scale-105"
//                   style={{ backgroundColor: colors.primary }}
//                 >
//                   Login
//                 </Link>
//               )}

//               {/* Mobile Menu Button */}
//               <button
//                 onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//                 className="md:hidden p-2 rounded-lg transition-all"
//                 style={{
//                   backgroundColor: colors.bgTertiary,
//                   color: colors.primary
//                 }}
//               >
//                 {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
//               </button>
//             </div>
//           </div>

//           {/* Mobile Search */}
//           <div className="md:hidden pb-3">
//             <div className="relative">
//               <div
//                 className="flex items-center gap-3 px-4 py-2.5 rounded-lg"
//                 style={{
//                   backgroundColor: colors.bgSecondary,
//                   border: `1px solid ${colors.border}`
//                 }}
//               >
//                 <Search size={18} style={{ color: colors.textSecondary }} />
//                 <input
//                   type="text"
//                   placeholder="Search..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   onKeyDown={handleSearch}
//                   className="flex-1 outline-none text-sm"
//                   style={{
//                     backgroundColor: 'transparent',
//                     color: colors.text
//                   }}
//                 />
//                 <button onClick={handleSearch} style={{ color: colors.primary }}>
//                   <Search size={18} />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Mobile Menu - Full Screen Overlay */}
//       {isMobileMenuOpen && (
//         <div
//           className="fixed inset-0 z-40 md:hidden"
//           style={{
//             top: user?._id ? '110px' : '110px', // Adjust based on header height
//             backgroundColor: colors.bg
//           }}
//         >
//           <div 
//             className="h-full overflow-y-auto overflow-x-hidden"
//             style={{
//               WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
//               scrollbarWidth: 'thin',
//               scrollbarColor: `${colors.primary} ${colors.bgSecondary}`
//             }}
//           >
//             <div className="px-4 py-4 space-y-3 pb-20">
//               {user?._id && (
//                 <>
//                   <div className="flex items-center gap-4 p-4 rounded-xl relative overflow-hidden group"
//                     style={{ 
//                       background: `linear-gradient(135deg, ${colors.primary}20, ${colors.accent}20)`,
//                       border: `1px solid ${colors.border}`
//                     }}>
//                     <div className="relative flex-shrink-0">
//                       {profilePicUrl ? (
//                         <img 
//                           src={profilePicUrl} 
//                           alt={user.firstName} 
//                           className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover border-3 shadow-lg"
//                           style={{ borderColor: colors.primary }}
//                           onError={(e) => {
//                             e.target.onerror = null;
//                             e.target.style.display = 'none';
//                             e.target.nextSibling.style.display = 'flex';
//                           }}
//                         />
//                       ) : null}
//                       <div
//                         className={`${profilePicUrl ? 'hidden' : 'flex'} w-14 h-14 sm:w-16 sm:h-16 rounded-full items-center justify-center text-white font-bold border-3 shadow-lg`}
//                         style={{ 
//                           background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//                           borderColor: colors.primary
//                         }}
//                       >
//                         {user.firstName?.charAt(0) || 'U'}
//                       </div>
//                       <div 
//                         className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 shadow-lg"
//                         style={{ 
//                           backgroundColor: '#10b981',
//                           borderColor: colors.bg
//                         }}
//                       />
//                     </div>
//                     <div className="flex-1 min-w-0">
//                       <p className="font-bold text-base sm:text-lg truncate" style={{ color: colors.text }}>{user?.firstName} {user?.lastName}</p>
//                       <p style={{ color: colors.textSecondary }} className="text-xs sm:text-sm truncate">{user?.email}</p>
//                     </div>
//                     <Sparkles size={20} style={{ color: colors.accent }} className="flex-shrink-0" />
//                   </div>

//                   <button 
//                     onClick={handleEditProfile}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95 text-white relative overflow-hidden group"
//                     style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}>
//                     <div 
//                       className="absolute inset-0 opacity-0 group-active:opacity-100 transition-opacity"
//                       style={{
//                         background: `linear-gradient(135deg, ${colors.accent}, ${colors.primary})`
//                       }}
//                     />
//                     <User size={20} className="relative flex-shrink-0" />
//                     <span className="relative font-medium">Edit Profile</span>
//                   </button>

//                   <Link
//                     to="/orders"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: `${colors.accent}15` }}
//                     >
//                       <Package size={20} style={{ color: colors.accent }} />
//                     </div>
//                     <span className="font-medium">Order History</span>
//                   </Link>

//                   <div className="px-2 pt-2">
//                     <div className="text-xs font-semibold mb-2 uppercase tracking-wider" style={{ color: colors.textSecondary }}>
//                       Gift Cards
//                     </div>
//                   </div>

//                   <Link
//                     to="/purchase-giftcard"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: '#10b98115' }}
//                     >
//                       <Gift size={20} style={{ color: '#10b981' }} />
//                     </div>
//                     <span className="font-medium">Send Gift Card</span>
//                   </Link>

//                   <Link
//                     to="/my-giftcards"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: '#10b98115' }}
//                     >
//                       <CreditCard size={20} style={{ color: '#10b981' }} />
//                     </div>
//                     <span className="font-medium">My Gift Cards</span>
//                   </Link>

//                   <Link
//                     to="/received-giftcards"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: '#10b98115' }}
//                     >
//                       <Mail size={20} style={{ color: '#10b981' }} />
//                     </div>
//                     <span className="font-medium">Received Gifts</span>
//                   </Link>

//                   <div className="px-2 pt-2">
//                     <div className="text-xs font-semibold mb-2 uppercase tracking-wider" style={{ color: colors.textSecondary }}>
//                       Trade-Ins
//                     </div>
//                   </div>

//                   <Link
//                     to="/liked-products"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: `${colors.accent}15` }}
//                     >
//                       <Heart size={20} style={{ color: colors.accent }} fill="none" />
//                     </div>
//                     <span className="font-medium">Liked Products</span>
//                   </Link>

//                   <Link 
//                     to="/my-tradeins"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: `${colors.accent}15` }}
//                     >
//                       <RefreshCw size={20} style={{ color: colors.accent }} fill="none" />
//                     </div>
//                     <span className="font-medium">My Trade-Ins</span>
//                   </Link>

//                   <Link 
//                     to="/submit-tradein"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: `${colors.accent}15` }}
//                     >
//                       <Upload size={20} style={{ color: colors.accent }} fill="none" />
//                     </div>
//                     <span className="font-medium">Submit Trade-In</span>
//                   </Link>

//                   <div className="px-2 pt-2">
//                     <div className="text-xs font-semibold mb-2 uppercase tracking-wider" style={{ color: colors.textSecondary }}>
//                       Repairs
//                     </div>
//                   </div>

//                   <Link 
//                     to="/repair-requests"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: `${colors.accent}15` }}
//                     >
//                       <Wrench size={20} style={{ color: colors.accent }} />
//                     </div>
//                     <span className="font-medium">Request Repairs</span>
//                   </Link>

//                   <Link 
//                     to="/repair-lists"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: `${colors.accent}15` }}
//                     >
//                       <Smartphone size={20} style={{ color: colors.accent }} />
//                     </div>
//                     <span className="font-medium">Repair Lists</span>
//                   </Link>

//                   {isAdminRole(user?.role) && (
//                     <Link
//                       to="/admin"
//                       onClick={closeMobileMenu}
//                       className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95"
//                       style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                       <div 
//                         className="p-2 rounded-lg flex-shrink-0"
//                         style={{ backgroundColor: `${colors.primary}15` }}
//                       >
//                         <Settings size={20} style={{ color: colors.primary }} />
//                       </div>
//                       <span className="font-medium">Admin Panel</span>
//                     </Link>
//                   )}

//                   <Link
//                     to="/cart"
//                     onClick={closeMobileMenu}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95 relative"
//                     style={{ backgroundColor: colors.bgTertiary, color: colors.text }}>
//                     <div 
//                       className="p-2 rounded-lg flex-shrink-0"
//                       style={{ backgroundColor: `${colors.primary}15` }}
//                     >
//                       <ShoppingCart size={20} style={{ color: colors.primary }} />
//                     </div>
//                     <span className="font-medium flex-1">Cart</span>
//                     {context?.cartCount > 0 && (
//                       <span
//                         className="px-3 py-1 rounded-full text-xs font-bold text-white flex-shrink-0"
//                         style={{ backgroundColor: colors.accent }}
//                       >
//                         {context.cartCount}
//                       </span>
//                     )}
//                   </Link>

//                   <button
//                     onClick={handleLogout}
//                     className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-xl transition-all active:scale-95 text-white relative overflow-hidden group"
//                     style={{ background: `linear-gradient(135deg, ${colors.accent}, ${colors.accent}dd)` }}>
//                     <div 
//                       className="absolute inset-0 opacity-0 group-active:opacity-100 transition-opacity"
//                       style={{
//                         background: `linear-gradient(135deg, ${colors.accent}dd, ${colors.accent})`
//                       }}
//                     />
//                     <LogOut size={20} className="relative flex-shrink-0" />
//                     <span className="relative font-semibold">Logout</span>
//                   </button>
//                 </>
//               )}

//               {!user?._id && (
//                 <Link
//                   to="/login"
//                   onClick={closeMobileMenu}
//                   className="w-full flex items-center justify-center px-4 py-3 rounded-xl transition-all active:scale-95 text-white font-bold relative overflow-hidden group"
//                   style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}>
//                   <div 
//                     className="absolute inset-0 opacity-0 group-active:opacity-100 transition-opacity"
//                     style={{
//                       background: `linear-gradient(135deg, ${colors.accent}, ${colors.primary})`
//                     }}
//                   />
//                   <span className="relative">Login</span>
//                 </Link>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes slideIn {
//           from { 
//             transform: translateY(-10px) scale(0.95); 
//             opacity: 0; 
//           }
//           to { 
//             transform: translateY(0) scale(1); 
//             opacity: 1; 
//           }
//         }

//         .animate-slideIn {
//           animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
//         }

//         /* Custom scrollbar for webkit browsers */
//         ::-webkit-scrollbar {
//           width: 6px;
//         }

//         ::-webkit-scrollbar-track {
//           background: ${colors.bgSecondary};
//         }

//         ::-webkit-scrollbar-thumb {
//           background: ${colors.primary};
//           border-radius: 3px;
//         }

//         ::-webkit-scrollbar-thumb:hover {
//           background: ${colors.accent};
//         }

//         /* Smooth scrolling for all browsers */
//         * {
//           -webkit-overflow-scrolling: touch;
//           scroll-behavior: smooth;
//         }

//         /* Firefox scrollbar */
//         * {
//           scrollbar-width: thin;
//           scrollbar-color: ${colors.primary} ${colors.bgSecondary};
//         }
//       `}</style>
//     </>
//   );
// };

// export default Header;






import React, { useState, useEffect, useRef, useContext } from 'react';
import { 
  Search, Menu, X, ShoppingCart, User, LogOut, 
  Package, Settings, ChevronDown, Bell, Heart, Smartphone, Wrench,
  RefreshCw, Upload, Gift, CreditCard, Mail, Sparkles, Phone
} from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { summaryApi } from '../../common';
import { toast } from 'react-toastify';
import { setUserDetails } from '../../store/userSlice';
import { isAdminRole } from '../../common/role';
import Context from '../../context';
import { logo1 } from '../Logo/Logo';
import NotificationBell from '../Notification/NotificationBell';
import { authFetch } from '../../helpers/authFetch';

const Header = () => {
  const user = useSelector((state) => state?.user?.user);
  const dispatch = useDispatch();
  const context = useContext(Context);
  const navigate = useNavigate();

  const [selectedLogo, setSelectedLogo] = useState(logo1);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const profileRef = useRef(null);
  const dropdownRef = useRef(null);

  const searchInput = useLocation();
  const URLSearch = new URLSearchParams(searchInput?.search);
  const searchQueryParam = URLSearch.getAll("q");

  // Define elegant color palette
  const colors = {
    primary: '#2563eb', // Elegant blue
    primaryLight: '#60a5fa',
    primaryDark: '#1d4ed8',
    accent: '#7c3aed', // Elegant purple
    accentLight: '#a78bfa',
    bg: '#ffffff',
    bgSecondary: '#f8fafc',
    bgTertiary: '#f1f5f9',
    text: '#1e293b',
    textSecondary: '#64748b',
    textLight: '#94a3b8',
    border: '#e2e8f0',
    shadow: 'rgba(30, 41, 59, 0.08)',
    success: '#10b981',
    danger: '#ef4444'
  };

  const getFullImageUrl = (user) => {
    if (!user) return null;
    
    const picturePath = user.picturePath;
    
    if (!picturePath) return null;
    
    if (picturePath.startsWith('http')) {
      return picturePath;
    }
    
    const cleanPath = picturePath.replace(/\\/g, '/').replace(/^\/+/, '');
    return `${process.env.REACT_APP_BACKEND_URL}/${cleanPath}`;
  };

  const profilePicUrl = getFullImageUrl(user);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
      } catch (error) {
        console.error("Error parsing stored user:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (searchQueryParam.length > 0) {
      setSearchQuery(searchQueryParam[0]);
    }
  }, [searchQueryParam]);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setIsProfileOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const fetchCurrentLogo = async () => {
      try {
        const response = await fetch(summaryApi.getLogo.url, {
          method: summaryApi.getLogo.method,
          
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.success && data.logo) {
            setSelectedLogo(data.logo.cloudinaryUrl);
          } else {
            setSelectedLogo(logo1);
          }
        } else {
          setSelectedLogo(logo1);
        }
      } catch (error) {
        console.error('Error fetching logo:', error);
        setSelectedLogo(logo1);
      }
    };

    fetchCurrentLogo();
  }, []);

  const handleLogout = async () => {
    const response = await authFetch(summaryApi.logout.url, {
      method: summaryApi.logout.method,
      
    });
    const data = await response.json();

    if (data.success) {
      toast.success(data.message);
      dispatch(setUserDetails(null));
      localStorage.removeItem("token");
      setIsMobileMenuOpen(false);
      setIsProfileOpen(false);
      navigate("/");
    }

    if (data.error) {
      toast.error(data.message);
    }
  };

  const handleSearch = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      if (searchQuery.trim()) {
        navigate(`/search?q=${searchQuery}`);
        setIsMobileMenuOpen(false);
      }
    }
  };

  const handleEditProfile = () => {
    setIsProfileOpen(false);
    setIsMobileMenuOpen(false);
    navigate('/profile');
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header
        className="fixed w-full top-0 z-50 transition-all duration-300"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          borderBottom: `1px solid ${colors.border}`,
          boxShadow: isScrolled ? '0 4px 30px rgba(0, 0, 0, 0.05)' : 'none'
        }}
      >
        {/* Top Accent Bar */}
        <div
          className="h-1 w-full"
          style={{
            background: `linear-gradient(90deg, ${colors.primary}, ${colors.accent})`,
            backgroundSize: '200% 100%',
            animation: 'gradientFlow 3s ease infinite'
          }}
        />

        <div className="max-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            
            {/* Logo Section */}
            <Link to="/" className="flex-shrink-0 group">
              <div className="flex items-center gap-3 cursor-pointer">
                <div className="relative">
                  <div
                    className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center overflow-hidden transition-all duration-300 group-hover:scale-105 group-hover:shadow-lg"
                    style={{ 
                      background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                      boxShadow: '0 4px 20px rgba(37, 99, 235, 0.15)'
                    }}
                  >
                    {selectedLogo ? (
                      selectedLogo.endsWith('.mp4') || selectedLogo.includes('/video/') ? (
                        <video
                          src={selectedLogo}
                          className="h-full w-full object-cover"
                          autoPlay
                          muted
                          loop
                          playsInline
                        />
                      ) : (
                        <img
                          src={selectedLogo}
                          alt="Company Logo"
                          className="h-full w-full object-cover"
                        />
                      )
                    ) : (
                      <div className="h-full w-full bg-white/10 flex items-center justify-center">
                        <Phone size={24} className="text-white" />
                      </div>
                    )}
                  </div>
                  <div className="absolute -inset-2 bg-gradient-to-r from-blue-400/20 to-purple-400/20 rounded-xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10" />
                </div>
                <div className="hidden sm:block">
                  <h1 className="text-xl font-bold text-gray-900 tracking-tight">JosiePhones</h1>
                  <p className="text-xs text-gray-500 font-medium">Premium Mobile Solutions</p>
                </div>
              </div>
            </Link>

            {/* Desktop Search Bar */}
            <div className="hidden lg:flex flex-1 max-w-2xl mx-8">
              <div className="w-full relative group">
                <div className="relative flex items-center">
                  <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full blur opacity-0 group-hover:opacity-20 transition-opacity duration-300" />
                  <div
                    className="relative flex items-center gap-3 px-6 py-3 w-full rounded-full transition-all duration-300 group-hover:shadow-lg"
                    style={{
                      backgroundColor: colors.bg,
                      border: `2px solid ${colors.border}`,
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.03)'
                    }}
                  >
                    <Search size={20} style={{ color: colors.primary }} />
                    <input
                      type="text"
                      placeholder="Search for phones, accessories, and more..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onKeyDown={handleSearch}
                      className="flex-1 outline-none text-sm placeholder-gray-400"
                      style={{
                        backgroundColor: 'transparent',
                        color: colors.text
                      }}
                    />
                    <button
                      onClick={handleSearch}
                      className="transition-all duration-200 hover:scale-110 active:scale-95"
                      style={{ color: colors.primary }}
                    >
                      <Search size={20} />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Actions */}
            <div className="flex items-center gap-3 sm:gap-4">
              {/* Desktop Actions */}
              <div className="hidden lg:flex items-center gap-3">
                {user?._id && (
                  <NotificationBell />
                )}

                {user?._id && (
                  <Link 
                    to="/liked-products"
                    className="relative p-2.5 rounded-xl transition-all duration-200 hover:scale-110 hover:shadow-lg group"
                    style={{
                      backgroundColor: 'white',
                      border: `1px solid ${colors.border}`
                    }}
                    title="Liked Products"
                  >
                    <Heart 
                      size={22} 
                      className="transition-all duration-300 group-hover:fill-red-400 group-hover:text-red-400" 
                      style={{ color: colors.textSecondary }}
                    />
                    <div className="absolute -inset-1 bg-gradient-to-r from-red-400/0 via-red-400/10 to-pink-400/0 rounded-xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10" />
                  </Link>
                )}

                {user?._id && (
                  <Link to="/cart" className="relative group">
                    <button
                      className="p-2.5 rounded-xl transition-all duration-200 hover:scale-110 hover:shadow-lg relative"
                      style={{
                        backgroundColor: 'white',
                        border: `1px solid ${colors.border}`
                      }}
                      title="Shopping Cart"
                    >
                      <ShoppingCart size={22} style={{ color: colors.primary }} />
                      {context?.cartCount > 0 && (
                        <span
                          className="absolute -top-1 -right-1 w-6 h-6 rounded-full text-xs font-bold flex items-center justify-center text-white shadow-lg"
                          style={{ 
                            background: `linear-gradient(135deg, ${colors.accent}, ${colors.primary})`,
                            border: '2px solid white'
                          }}
                        >
                          {context.cartCount}
                        </span>
                      )}
                    </button>
                    <div className="absolute -inset-2 bg-gradient-to-r from-blue-400/0 via-blue-400/10 to-purple-400/0 rounded-xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10" />
                  </Link>
                )}
              </div>

              {/* Profile Section - Desktop */}
              {user?._id ? (
                <div className="relative" ref={profileRef}>
                  <button
                    onClick={() => setIsProfileOpen(!isProfileOpen)}
                    className="hidden md:flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all duration-200 hover:shadow-lg group"
                    style={{
                      backgroundColor: 'white',
                      border: `1px solid ${colors.border}`,
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
                    }}
                  >
                    <div className="relative">
                      {profilePicUrl ? (
                        <img 
                          src={profilePicUrl} 
                          alt={user.firstName} 
                          className="w-10 h-10 rounded-full object-cover border-2 shadow-sm transition-all duration-300 group-hover:scale-110"
                          style={{ borderColor: colors.primary }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                      ) : null}
                      <div
                        className={`${profilePicUrl ? 'hidden' : 'flex'} w-10 h-10 rounded-full items-center justify-center text-white font-bold text-sm border-2 shadow-sm transition-all duration-300 group-hover:scale-110`}
                        style={{ 
                          background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                          borderColor: colors.primary
                        }}
                      >
                        {user.firstName?.charAt(0) || 'U'}
                      </div>
                      <div 
                        className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 shadow-sm"
                        style={{ 
                          backgroundColor: colors.success,
                          borderColor: 'white'
                        }}
                      />
                    </div>

                    <div className="text-left">
                      <p className="text-sm font-semibold text-gray-900 leading-tight">
                        Hi, {user?.firstName}
                      </p>
                      <p className="text-xs text-gray-500">Your account</p>
                    </div>
                    <ChevronDown
                      size={18}
                      className={`transition-transform duration-200 ${isProfileOpen ? 'rotate-180' : ''}`}
                      style={{ color: colors.textSecondary }}
                    />
                  </button>

                  {/* Profile Dropdown Menu */}
                  {isProfileOpen && (
                    <div
                      ref={dropdownRef}
                      className="absolute right-0 mt-3 w-80 rounded-2xl shadow-xl overflow-hidden animate-slideIn backdrop-blur-xl"
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.98)',
                        border: `1px solid ${colors.border}`,
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
                        maxHeight: 'calc(100vh - 100px)',
                        overflowY: 'auto'
                      }}
                    >
                      {/* Profile Header */}
                      <div
                        className="relative p-6 overflow-hidden"
                        style={{ 
                          background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                        }}
                      >
                        <div className="absolute inset-0 bg-white/5" />
                        <div className="relative flex flex-col items-center text-center gap-4">
                          <div className="relative group/avatar">
                            {profilePicUrl ? (
                              <img 
                                src={profilePicUrl} 
                                alt={user.firstName} 
                                className="relative w-20 h-20 rounded-full object-cover border-4 shadow-2xl transition-transform duration-300 group-hover/avatar:scale-110"
                                style={{ borderColor: 'rgba(255,255,255,0.9)' }}
                              />
                            ) : null}
                            <div
                              className={`${profilePicUrl ? 'hidden' : 'flex'} relative w-20 h-20 rounded-full items-center justify-center text-2xl font-bold text-white border-4 shadow-2xl transition-transform duration-300 group-hover/avatar:scale-110`}
                              style={{ 
                                background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                                borderColor: 'rgba(255,255,255,0.9)'
                              }}
                            >
                              {user.firstName?.charAt(0) || 'U'}
                            </div>
                            <div 
                              className="absolute -top-1 -right-1 p-1.5 rounded-full shadow-lg"
                              style={{ backgroundColor: '#fbbf24' }}
                            >
                              <Sparkles size={12} color="white" fill="white" />
                            </div>
                          </div>
                          
                          <div>
                            <p className="font-bold text-white text-lg">{user?.firstName} {user?.lastName}</p>
                            <p className="text-sm text-white/90 mt-1">{user?.email}</p>
                          </div>
                        </div>
                      </div>

                      {/* Menu Items */}
                      <div className="py-3 px-2">
                        <button 
                          onClick={handleEditProfile}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ 
                            color: colors.text, 
                            backgroundColor: 'transparent',
                          }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, ${colors.primary}15, ${colors.primary}05)` }}
                          >
                            <User size={20} style={{ color: colors.primary }} />
                          </div>
                          <div className="flex-1 text-left">
                            <div className="text-sm font-semibold">Edit Profile</div>
                            <div className="text-xs" style={{ color: colors.textSecondary }}>Update your information</div>
                          </div>
                        </button>

                        <Link 
                          to="/orders"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ color: colors.text, backgroundColor: 'transparent' }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}
                          >
                            <Package size={20} style={{ color: colors.accent }} />
                          </div>
                          <div className="flex-1 text-left">
                            <div className="text-sm font-semibold">Order History</div>
                            <div className="text-xs" style={{ color: colors.textSecondary }}>Track your orders</div>
                          </div>
                        </Link>

                        {/* Gift Cards Section */}
                        <div className="px-4 py-2">
                          <div className="text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: colors.textSecondary }}>
                            Gift Cards
                          </div>
                        </div>

                        <Link 
                          to="/purchase-giftcard"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ color: colors.text, backgroundColor: 'transparent' }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, #10b98115, #10b98105)` }}
                          >
                            <Gift size={20} style={{ color: colors.success }} />
                          </div>
                          <span className="text-sm font-medium">Send Gift Card</span>
                        </Link>

                        <Link 
                          to="/my-giftcards"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ color: colors.text, backgroundColor: 'transparent' }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, #10b98115, #10b98105)` }}
                          >
                            <CreditCard size={20} style={{ color: colors.success }} />
                          </div>
                          <span className="text-sm font-medium">My Gift Cards</span>
                        </Link>

                        <Link 
                          to="/received-giftcards"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ color: colors.text, backgroundColor: 'transparent' }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, #10b98115, #10b98105)` }}
                          >
                            <Mail size={20} style={{ color: colors.success }} />
                          </div>
                          <span className="text-sm font-medium">Received Gifts</span>
                        </Link>

                        {/* Trade-Ins Section */}
                        <div className="px-4 py-2">
                          <div className="text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: colors.textSecondary }}>
                            Trade-Ins
                          </div>
                        </div>

                        <Link 
                          to="/my-tradeins"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ color: colors.text, backgroundColor: 'transparent' }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}
                          >
                            <RefreshCw size={20} style={{ color: colors.accent }} />
                          </div>
                          <span className="text-sm font-medium">My Trade-Ins</span>
                        </Link>

                        <Link 
                          to="/submit-tradein"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ color: colors.text, backgroundColor: 'transparent' }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}
                          >
                            <Upload size={20} style={{ color: colors.accent }} />
                          </div>
                          <span className="text-sm font-medium">Submit Trade-In</span>
                        </Link>

                        {/* Repairs Section */}
                        <div className="px-4 py-2">
                          <div className="text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: colors.textSecondary }}>
                            Repair Requests
                          </div>
                        </div>

                        <Link 
                          to="/repair-requests"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ color: colors.text, backgroundColor: 'transparent' }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}
                          >
                            <Wrench size={20} style={{ color: colors.accent }} />
                          </div>
                          <span className="text-sm font-medium">Request Repairs</span>
                        </Link>

                        <Link 
                          to="/repair-lists"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ color: colors.text, backgroundColor: 'transparent' }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}
                          >
                            <Smartphone size={20} style={{ color: colors.accent }} />
                          </div>
                          <span className="text-sm font-medium">Repair Lists</span>
                        </Link>

                        {isAdminRole(user?.role) && (
                          <>
                            <div className="px-4 py-2">
                              <div className="text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: colors.textSecondary }}>
                                Administration
                              </div>
                            </div>
                            <Link
                              to="/admin"
                              onClick={() => setIsProfileOpen(false)}
                              className="w-full px-4 py-3 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                              style={{ color: colors.text, backgroundColor: 'transparent' }}>
                              <div 
                                className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                                style={{ background: `linear-gradient(135deg, ${colors.primary}15, ${colors.primary}05)` }}
                              >
                                <Settings size={20} style={{ color: colors.primary }} />
                              </div>
                              <span className="text-sm font-medium">Admin Panel</span>
                            </Link>
                          </>
                        )}
                      </div>

                      {/* Cart and Logout Section */}
                      <div className="p-3 space-y-2">
                        <Link 
                          to="/cart"
                          onClick={() => setIsProfileOpen(false)}
                          className="w-full px-4 py-3.5 flex items-center gap-3 rounded-xl hover:scale-[1.02] transition-all duration-200 group/item"
                          style={{ 
                            color: colors.text, 
                            background: `linear-gradient(135deg, ${colors.primary}08, ${colors.primary}02)`,
                            border: `1px solid ${colors.border}`
                          }}>
                          <div 
                            className="p-2.5 rounded-xl group-hover/item:scale-110 transition-transform duration-200"
                            style={{ background: `linear-gradient(135deg, ${colors.primary}15, ${colors.primary}05)` }}
                          >
                            <ShoppingCart size={20} style={{ color: colors.primary }} />
                          </div>
                          <div className="flex-1 text-left">
                            <div className="text-sm font-semibold">Shopping Cart</div>
                            {context?.cartCount > 0 && (
                              <div className="text-xs font-medium" style={{ color: colors.accent }}>
                                {context.cartCount} item{context.cartCount !== 1 ? 's' : ''} in cart
                              </div>
                            )}
                          </div>
                          <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
                        </Link>

                        <button 
                          onClick={handleLogout}
                          className="w-full px-4 py-3.5 flex items-center justify-center gap-3 rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-95 group/logout relative overflow-hidden"
                          style={{ 
                            color: 'white',
                            background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                            boxShadow: '0 4px 15px rgba(124, 58, 237, 0.25)'
                          }}>
                          <div 
                            className="absolute inset-0 opacity-0 group-hover/logout:opacity-100 transition-opacity duration-300"
                            style={{
                              background: `linear-gradient(135deg, ${colors.accent}, ${colors.primary})`
                            }}
                          />
                          <LogOut size={18} className="relative" />
                          <span className="text-sm font-semibold relative">Logout</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  to="/login"
                  className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-white transition-all duration-200 hover:scale-105 hover:shadow-lg"
                  style={{ 
                    background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                    boxShadow: '0 4px 15px rgba(37, 99, 235, 0.25)'
                  }}
                >
                  <User size={18} />
                  <span>Login</span>
                </Link>
              )}

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="md:hidden p-2.5 rounded-xl transition-all duration-200 hover:scale-110 hover:shadow-lg"
                style={{
                  backgroundColor: 'white',
                  border: `1px solid ${colors.border}`,
                  color: colors.primary
                }}
              >
                {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Search */}
          <div className="md:hidden pb-4 pt-2">
            <div className="relative">
              <div
                className="flex items-center gap-3 px-4 py-3.5 rounded-xl"
                style={{
                  backgroundColor: colors.bg,
                  border: `2px solid ${colors.border}`,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.03)'
                }}
              >
                <Search size={20} style={{ color: colors.primary }} />
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={handleSearch}
                  className="flex-1 outline-none text-sm placeholder-gray-400"
                  style={{
                    backgroundColor: 'transparent',
                    color: colors.text
                  }}
                />
                <button onClick={handleSearch} style={{ color: colors.primary }}>
                  <Search size={20} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu - Full Screen Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 z-40 md:hidden"
          style={{
            top: '120px',
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(20px)'
          }}
        >
          <div 
            className="h-full overflow-y-auto overflow-x-hidden"
            style={{
              WebkitOverflowScrolling: 'touch',
              scrollbarWidth: 'thin',
              scrollbarColor: `${colors.primary} ${colors.bgSecondary}`
            }}
          >
            <div className="px-5 py-6 space-y-3 pb-24">
              {user?._id && (
                <>
                  {/* User Profile Section */}
                  <div className="flex items-center gap-4 p-5 rounded-2xl relative overflow-hidden group"
                    style={{ 
                      background: `linear-gradient(135deg, ${colors.primary}15, ${colors.accent}10)`,
                      border: `1px solid ${colors.border}`
                    }}>
                    <div className="relative flex-shrink-0">
                      {profilePicUrl ? (
                        <img 
                          src={profilePicUrl} 
                          alt={user.firstName} 
                          className="w-16 h-16 rounded-full object-cover border-3 shadow-lg"
                          style={{ borderColor: colors.primary }}
                        />
                      ) : null}
                      <div
                        className={`${profilePicUrl ? 'hidden' : 'flex'} w-16 h-16 rounded-full items-center justify-center text-white font-bold text-lg border-3 shadow-lg`}
                        style={{ 
                          background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                          borderColor: colors.primary
                        }}
                      >
                        {user.firstName?.charAt(0) || 'U'}
                      </div>
                      <div 
                        className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 shadow-lg"
                        style={{ 
                          backgroundColor: colors.success,
                          borderColor: 'white'
                        }}
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-lg text-gray-900 truncate">{user?.firstName} {user?.lastName}</p>
                      <p className="text-sm text-gray-600 truncate">{user?.email}</p>
                    </div>
                    <Sparkles size={20} style={{ color: colors.accent }} className="flex-shrink-0" />
                  </div>

                  {/* Quick Actions */}
                  <div className="grid grid-cols-2 gap-3">
                    <button 
                      onClick={handleEditProfile}
                      className="flex flex-col items-center justify-center p-4 rounded-xl transition-all duration-200 active:scale-95 group"
                      style={{ 
                        backgroundColor: 'white',
                        border: `1px solid ${colors.border}`
                      }}
                    >
                      <div className="p-3 rounded-lg mb-2 transition-transform duration-200 group-active:scale-110"
                        style={{ background: `linear-gradient(135deg, ${colors.primary}15, ${colors.primary}05)` }}>
                        <User size={22} style={{ color: colors.primary }} />
                      </div>
                      <span className="text-sm font-medium">Profile</span>
                    </button>

                    <Link
                      to="/orders"
                      onClick={closeMobileMenu}
                      className="flex flex-col items-center justify-center p-4 rounded-xl transition-all duration-200 active:scale-95 group"
                      style={{ 
                        backgroundColor: 'white',
                        border: `1px solid ${colors.border}`
                      }}
                    >
                      <div className="p-3 rounded-lg mb-2 transition-transform duration-200 group-active:scale-110"
                        style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}>
                        <Package size={22} style={{ color: colors.accent }} />
                      </div>
                      <span className="text-sm font-medium">Orders</span>
                    </Link>
                  </div>

                  {/* Menu Sections */}
                  {['Gift Cards', 'Trade-Ins', 'Repairs'].map((section, idx) => (
                    <div key={section} className="pt-4">
                      <div className="text-xs font-semibold uppercase tracking-wider mb-3 px-2" style={{ color: colors.textSecondary }}>
                        {section}
                      </div>
                      <div className="space-y-2">
                        {section === 'Gift Cards' && (
                          <>
                            <Link
                              to="/purchase-giftcard"
                              onClick={closeMobileMenu}
                              className="flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95"
                              style={{ backgroundColor: 'white', border: `1px solid ${colors.border}` }}
                            >
                              <div className="p-2.5 rounded-lg" style={{ backgroundColor: '#10b98115' }}>
                                <Gift size={20} style={{ color: colors.success }} />
                              </div>
                              <span className="font-medium">Send Gift Card</span>
                            </Link>
                            <Link
                              to="/my-giftcards"
                              onClick={closeMobileMenu}
                              className="flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95"
                              style={{ backgroundColor: 'white', border: `1px solid ${colors.border}` }}
                            >
                              <div className="p-2.5 rounded-lg" style={{ backgroundColor: '#10b98115' }}>
                                <CreditCard size={20} style={{ color: colors.success }} />
                              </div>
                              <span className="font-medium">My Gift Cards</span>
                            </Link>
                          </>
                        )}
                        {section === 'Trade-Ins' && (
                          <>
                            <Link
                              to="/liked-products"
                              onClick={closeMobileMenu}
                              className="flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95"
                              style={{ backgroundColor: 'white', border: `1px solid ${colors.border}` }}
                            >
                              <div className="p-2.5 rounded-lg" style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}>
                                <Heart size={20} style={{ color: colors.accent }} />
                              </div>
                              <span className="font-medium">Liked Products</span>
                            </Link>
                            <Link
                              to="/my-tradeins"
                              onClick={closeMobileMenu}
                              className="flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95"
                              style={{ backgroundColor: 'white', border: `1px solid ${colors.border}` }}
                            >
                              <div className="p-2.5 rounded-lg" style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}>
                                <RefreshCw size={20} style={{ color: colors.accent }} />
                              </div>
                              <span className="font-medium">My Trade-Ins</span>
                            </Link>
                          </>
                        )}
                        {section === 'Repairs' && (
                          <>
                            <Link
                              to="/repair-requests"
                              onClick={closeMobileMenu}
                              className="flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95"
                              style={{ backgroundColor: 'white', border: `1px solid ${colors.border}` }}
                            >
                              <div className="p-2.5 rounded-lg" style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}>
                                <Wrench size={20} style={{ color: colors.accent }} />
                              </div>
                              <span className="font-medium">Request Repairs</span>
                            </Link>
                            <Link
                              to="/repair-lists"
                              onClick={closeMobileMenu}
                              className="flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95"
                              style={{ backgroundColor: 'white', border: `1px solid ${colors.border}` }}
                            >
                              <div className="p-2.5 rounded-lg" style={{ background: `linear-gradient(135deg, ${colors.accent}15, ${colors.accent}05)` }}>
                                <Smartphone size={20} style={{ color: colors.accent }} />
                              </div>
                              <span className="font-medium">Repair Lists</span>
                            </Link>
                          </>
                        )}
                      </div>
                    </div>
                  ))}

                  {/* Cart Section */}
                  <Link
                    to="/cart"
                    onClick={closeMobileMenu}
                    className="flex items-center justify-between px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95 mt-4"
                    style={{ 
                      background: `linear-gradient(135deg, ${colors.primary}08, ${colors.primary}02)`,
                      border: `1px solid ${colors.border}`
                    }}
                  >
                    <div className="flex items-center gap-3">
                      <div className="p-2.5 rounded-lg" style={{ background: `linear-gradient(135deg, ${colors.primary}15, ${colors.primary}05)` }}>
                        <ShoppingCart size={22} style={{ color: colors.primary }} />
                      </div>
                      <div>
                        <div className="font-semibold">Shopping Cart</div>
                        {context?.cartCount > 0 && (
                          <div className="text-sm" style={{ color: colors.accent }}>
                            {context.cartCount} items
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
                  </Link>

                  {/* Logout Button */}
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center justify-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95 text-white font-semibold mt-4 relative overflow-hidden group"
                    style={{ 
                      background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                      boxShadow: '0 4px 15px rgba(124, 58, 237, 0.25)'
                    }}
                  >
                    <div 
                      className="absolute inset-0 opacity-0 group-active:opacity-100 transition-opacity duration-300"
                      style={{
                        background: `linear-gradient(135deg, ${colors.accent}, ${colors.primary})`
                      }}
                    />
                    <LogOut size={20} className="relative" />
                    <span className="relative">Logout</span>
                  </button>
                </>
              )}

              {!user?._id && (
                <Link
                  to="/login"
                  onClick={closeMobileMenu}
                  className="w-full flex items-center justify-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 active:scale-95 text-white font-semibold relative overflow-hidden group"
                  style={{ 
                    background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
                    boxShadow: '0 4px 15px rgba(37, 99, 235, 0.25)'
                  }}
                >
                  <div 
                    className="absolute inset-0 opacity-0 group-active:opacity-100 transition-opacity duration-300"
                    style={{
                      background: `linear-gradient(135deg, ${colors.accent}, ${colors.primary})`
                    }}
                  />
                  <User size={20} className="relative" />
                  <span className="relative">Login to Account</span>
                </Link>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Add spacer to prevent content from hiding behind fixed header */}
      <div className="h-20 sm:h-24" />

      <style jsx>{`
        @keyframes slideIn {
          from { 
            transform: translateY(-10px) scale(0.98); 
            opacity: 0; 
          }
          to { 
            transform: translateY(0) scale(1); 
            opacity: 1; 
          }
        }

        @keyframes gradientFlow {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        .animate-slideIn {
          animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }

        ::-webkit-scrollbar {
          width: 6px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f5f9;
        }

        ::-webkit-scrollbar-thumb {
          background: linear-gradient(135deg, ${colors.primary}, ${colors.accent});
          border-radius: 3px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(135deg, ${colors.primaryDark}, ${colors.accent});
        }

        * {
          -webkit-overflow-scrolling: touch;
          scroll-behavior: smooth;
        }

        * {
          scrollbar-width: thin;
          scrollbar-color: ${colors.primary} #f1f5f9;
        }
      `}</style>
    </>
  );
};

export default Header;